import {CALL_API} from 'redux-api-middleware';
import {
  API_GRANT_BY_NUMBER_GET_SUCCESS,
  API_GRANT_BY_NUMBER_GET_FAILURE,
  API_GRANT_BY_NUMBER_GET_REQUEST,
} from 'common/types';
import {ENDPOINT_GRANT} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

// grant svc is deprecated, use dynamicData service for new api calls

export default {
  getGrantByGrantNumber: (token, grantId) => {
 
    const endpointToUse = `${ENDPOINT_GRANT}?grantId=${grantId}`;
    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_GRANT_BY_NUMBER_GET_REQUEST,
          API_GRANT_BY_NUMBER_GET_SUCCESS,
          API_GRANT_BY_NUMBER_GET_FAILURE,
        ],
      },
    };
  },
};
